export const WorkConfig = [{
    name: "MS admission analyzer",
    description: "This application analyzes the ms admissions and visualizes the statastics for better understanding. And also predicts the chances of getting admission in MS offering universities.",
    github: "https://github.com/drpratik/MS-admission-Predicitor",
    url: null,
    icon: null,
    chip: "M",
    techs: ["Python", "Machine Learning"]
},{
    name: "Online Training and Placement WebApp",
    description: "The application is capable of performing several operations such as Drive registration, eligible student shortlisting, list of selected or eligible student generation, login for management and cell head for smooth running of drive. ",
    chip:"O",
    techs:["Node js","MySQL","Bootstrap"]
},{
    name: "NASA OPEN API APP",
    description: "This application uses open space APIs provided by NASA itselft to show the information about space and the meteors",
    github: "https://github.com/DrPratik/NASA-OPEN-API-ANGULAR-APPLICATION",
    url: "https://nasa-api-application.web.app/",
    icon: null,
    chip: "A",
    techs: ["Angular 8"]
},{
    name: "React News App",
    description: "Web based News app where we can find the news.",
    github: "https://github.com/DrPratik/react-news-app",
    url: "https://news-app-79e4b.web.app/",
    icon: null,
    chip: "R",
    techs: ["REACT JS"]
} 
]